'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _SVGBase = require('./SVGBase');

var _SVGBase2 = _interopRequireDefault(_SVGBase);

var _Constants = require('../../Constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _styledComponents2.default)(_SVGBase2.default).withConfig({
  displayName: 'SVGWrapper'
})(['background-size:cover;background-position:center;display:block;fill:', ';font-family:\'Avenir Next W02\',Helvetica,Arial,sans-serif;font-size:', '%;text-anchor:middle;width:100%;height:', ';', ';', ';'], function (props) {
  return props._isHasMore ? _colors.OBSIDIAN : 'currentColor';
}, function (props) {
  return props._isHasMore ? '340' : '290';
}, function (props) {
  return props.size && props.size !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[props.size] + 'px' : 'inherit';
}, function (props) {
  return props.src ? 'background-image: url(\'' + props.src + '\');' : 'background-color: ' + (props._isHasMore ? _colors.OLAF : _colors.EERIE) + ';';
}, function (props) {
  return (/hubfs\/defaults\/company\.png/.test(props.src) && props._isReversed && 'background-position: -2px;'
  );
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2292/js/UIAvatarDisplay/baseStyledComponents/SVGWrapper.js
// module id = 84
// module chunks = 177